import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { map, take } from 'rxjs';
import { BlogFilter } from 'src/app/common/BlogFilter';
import { AppProfileService } from 'src/app/services/profile.service';
import { BlogService } from 'src/app/services/blog.service';
import {
  faEdit,
  faTrashAlt,
  faFilePdf,
} from '@fortawesome/free-solid-svg-icons';
import { ProfileRoleConstants } from 'src/app/common/ProfileRole';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { PagedList } from 'src/app/common/PagedList';
import { Blog } from 'src/app/common/Blog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BlogSearchBoxComponent } from '../blog-search-box/blog-search-box.component';
import { GridPdfColumnsDirective } from '../grid/grid-pdf-columns.directive';
import { PdfPageComponent } from '../grid/pdf-page.component';
import { GridNoRecordsComponent } from '../grid/grid-no-records.component';

@Component({
    imports: [KENDO_GRID, RouterModule, FontAwesomeModule, BlogSearchBoxComponent, GridPdfColumnsDirective, PdfPageComponent, GridNoRecordsComponent],
    selector: 'app-blog-list',
    templateUrl: './blog-list.component.html',
    styleUrls: ['./blog-list.component.css']
})
export class BlogListComponent implements OnInit {
  private blogService = inject(BlogService);
  private router = inject(Router);
  private profileService = inject(AppProfileService);

  public faEdit = faEdit;
  public faTrashAlt = faTrashAlt;
  public faFilePdf = faFilePdf;
  private filter = new BlogFilter();

  public isAdmin: boolean = false;
  public isCarrier: boolean = false;

  // #648: server-side paging/sorting; backend default order = created desc.
  public list = new PagedList<Blog>({
    sortFields: { validFrom: 'validFrom' },
    fetch: (paging) =>
      this.filter
        ? this.blogService.getBySearch(this.filter.validFrom, this.filter.validTo, paging).pipe(
            map((r) => {
              for (let element of r.items) {
                element.validFrom = element.validFrom ? new Date(element.validFrom) : null;
                element.validTo = element.validTo ? new Date(element.validTo) : null;
              }
              return r;
            })
          )
        : null,
  });

  ngOnInit(): void {
    this.filter = this.blogService.getDefaultFilter();
    this.profileService.currentProfile$.pipe(take(1)).subscribe((profile) => {
      this.isAdmin = profile.role == ProfileRoleConstants.RoleIdAdmin;
    });
    this.list.load();
  }

  search(filter: BlogFilter) {
    this.filter = filter;
    this.list.search();
  }

  public onEdit(blogId: string) {
    this.router.navigate(['/shop-blog-edit/' + blogId]);
  }
}
